import numeral from 'numeral';

const keys = (t) => [
    {
        key: 'clicks',
        label: t('search.keyword_clusters_detail.chart.avg_clicks'),
        icon: 'clicks',
        yAxisID: 'y3',
    },
    {
        key: 'impressions',
        label: t('search.keyword_clusters_detail.chart.avg_impressions'),
        icon: 'search',
    },
    {
        key: 'avgPosition',
        label: t('search.keyword_clusters_detail.chart.avg_position'),
        icon: 'pagev-view',
        yAxisID: 'y2',
    },
    {
        key: 'avgCTR',
        label: t('search.keyword_clusters_detail.chart.avg_ctr'),
        format: '0.00%',
        yAxisID: 'y1',
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'ctr',
    },
    {
        key: 'keywords',
        label: t('search.keyword_clusters_detail.chart.keywords'),
        icon: 'pagev-view',
        type: 'bar',
        yAxisID: 'y1',
        hidden: true,
    },
    {
        key: 'weekly_urls',
        label: t('search.keyword_clusters_detail.chart.avg_pages'),
        icon: 'pagev-view',
        type: 'bar',
        yAxisID: 'y1',
        hidden: true,
    },
];

export default keys;
